export default function() {

  // Variables
  let header = document.getElementById('header')
  
  // Functions
  function stick() {
    let position = window.pageYOffset
    if(position > 150) {
      header.classList.add('sticky')
    } else {
      header.classList.remove('sticky')
    }
  }
  
  // Events
  window.addEventListener('scroll', function() {
    stick()
  })
  
  document.addEventListener('swup:contentReplaced', function() {
    stick()
  })
  
}